export default "__VITE_ASSET__8060b56b__"